<template>
  <div
      class="contract-item"
      @click="isReady ? uiHandler.routeToContractItem(id) : uiHandler.showNotReadyModal()"
  >
    <div class="contract-image-container">
      <img :src="imgUrl"/>
    </div>
    <div class="contract-text-container">
      <div class="contract-title">{{ title }}</div>
      <div class="contract-modified-at" v-if="isReady">최종 수정일 {{ modifiedDate }}</div>
      <div class="not-ready" v-else>준비중</div>
    </div>
  </div>
</template>
<script>
// v2: 계약 유형 선택 화면(ContractTypeListV2)에서 쓰는 카드 아이템. v1 ContractItem.vue를
// 그대로 포팅했고, 유일한 차이는 클릭 시 이동하는 라우트 name 계산부다 — v1은 this.title을
// 그대로 라우트 name으로 쓰지만(=v1 create 라우트), v2는 title→v2 create 라우트 name 매핑
// (resolveContractCreateRouteName, ../routeMap.js)을 거친다. 매핑에 없는 title(아직 v2 create
// 화면이 없는 4종)은 v1 라우트 name으로 그대로 폴백한다 — 카드가 "존재하지 않는 라우트로
// 이동해 조용히 멈추는" 회귀를 막기 위함이다.
//
// query.name은 라우트 name과 별개로 항상 원래 title(모두싸인 템플릿 제목) 그대로 넘긴다 —
// 생성 화면 상단 제목(pageTitle = $route.query.name)이 v1과 완전히 동일해야 하기 때문이다.

import {logging, oneBtnDialog} from "@/utils/utils";
import contractsApiInstance from "@/contractsApi";
import {resolveContractCreateRouteName} from "@/views/ContractManagementV2/routeMap";

export default {
  name: 'ContractItemV2',
  components: {},
  props: {
    templateId: {
      type: String,
      required: true,
    },
    imgUrl: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    group: {
      type: String,
      required: false,
    },
    modifiedDate: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: true,
    },
    isReady: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),


    }
  },
  methods: {
    ui() {
      const routeToContractItem = (id) => {
        logging().exceptProd('contract item==>', this)
        this.$router.push({
              name: resolveContractCreateRouteName(this.title),
              params: {templateId: this.id,}, query: {name: this.title, group: this.group}
            }
        )
      }
      const showNotReadyModal = async () => {
        oneBtnDialog('서비스 준비 중', '서비스 준비 중입니다.', false);
      }
      return {
        routeToContractItem,
        showNotReadyModal,
      }
    },
    api() {
      return {
        getContracts: async (params, success, fail) => {
          this.calledApiTimes++;
          this.$store.commit('setIsLoading', true);
          return contractsApiInstance.post(`/contracts`, params)
              .then((response) => {
                logging().exceptProd('contract ==>', response.data)
                success(response);
              }, (error) => {
                fail(error);
              }).finally(() => this.$store.commit('setIsLoading', false));
        }
      }
    },
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/contract-type.scss';
</style>
